export default "/kiban/_next/static/images/boardThickness_FPC-5cf96bce8af6cefa1e768f75ead80bdb.png";